import React, { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export const PartnersWidget = ({ userId, className = "" }) => {
  const [items, setItems] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await axios.get(`${API}/api/partners${userId ? `?user_id=${userId}` : ""}`);
        if (mounted) setItems(res.data?.items || []);
      } catch {
        /* silent fallback to empty */
      }
    })();
    return () => { mounted = false; };
  }, [userId]);

  useEffect(() => {
    if (items.length < 2) return;
    const id = setInterval(() => {
      setActiveIndex((i) => (i + 1) % items.length);
    }, 3500);
    return () => clearInterval(id);
  }, [items.length]);

  if (items.length === 0) return null;
  const active = items[activeIndex % items.length];

  const Inner = (
    <img
      src={active.logo_url}
      alt={active.name}
      className="h-10 object-contain transition-opacity duration-500"
    />
  );

  return (
    <div
      className={`rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl p-5 ${className}`}
      data-testid="club-partners-widget"
    >
      <div className="flex items-center justify-between mb-3">
        <p className="text-xs font-medium text-white/60">Our Partners</p>
        <div className="flex gap-1">
          {items.map((item, idx) => (
            <div
              key={item.id || `${item.name}-${idx}`}
              className={`h-2 rounded-full transition-all duration-300 ${
                idx === activeIndex ? "w-4 bg-gradient-to-r from-[#493986] to-[#92a7e8]" : "w-2 bg-white/20"
              }`}
            />
          ))}
        </div>
      </div>
      {active.link_url ? (
        <a
          href={active.link_url}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full h-20 rounded-xl bg-white/5 flex items-center justify-center hover:scale-[1.02] transition-transform"
          data-testid={`club-partner-link-${(active.name || "").toLowerCase()}`}
        >
          {Inner}
        </a>
      ) : (
        <div className="w-full h-20 rounded-xl bg-white/5 flex items-center justify-center">
          {Inner}
        </div>
      )}
      {items.length > 1 && (
        <div className="flex justify-center gap-3 mt-3">
          {items.map((p, idx) => (
            <button
              key={p.id || p.name}
              type="button"
              onClick={() => {
                setActiveIndex(idx);
                if (p.link_url) window.open(p.link_url, "_blank");
              }}
              className={`w-9 h-9 rounded-lg flex items-center justify-center transition-all ${
                idx === activeIndex
                  ? "bg-gradient-to-r from-[#493986] to-[#92a7e8] scale-110"
                  : "bg-white/10 hover:bg-white/20"
              }`}
            >
              <img src={p.logo_url} alt={p.name} className="h-4 object-contain" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PartnersWidget;
